import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

// import { axios } from '../../../../../utils/axios';
// import { success, successAPI, errorAPI, getMaxPageSize, isNumeric } from '../../../../../utils/utils';
import Yup from '../../../../../utils/yup';
// import {  } from '../../../../../utils/enums';


export const fields = {
  isSaveAsGlobalService: {
    id: 'isSaveAsGlobalService',
    label: 'Apply to all customers',
    placeholder: '',
  },
  isSaveAsLocalService: {
    id: 'isSaveAsLocalService',
    label: '',
    placeholder: '',
  },
};


export const formSchema = (id: number|null= null) => {
  return Yup.object().shape({
    isSaveAsGlobalService: Yup.bool().oneOf([true, false]).label(fields.isSaveAsGlobalService.label),
    isSaveAsLocalService: Yup.bool().oneOf([true, false]).label(fields.isSaveAsLocalService.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareForm = (values: any = null, defValues: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);
  
  if(data && form){
    let isSaveAsGlobalService = (form.isSaveAsGlobalService === true || form.isSaveAsGlobalService == false) ? form.isSaveAsGlobalService : false;
    let isSaveAsLocalService = (form.isSaveAsLocalService === true || form.isSaveAsLocalService == false) ? form.isSaveAsLocalService : false;

    data['isSaveAsGlobalService'] = isSaveAsGlobalService;
    data['isSaveAsLocalService'] = isSaveAsLocalService;
  }
  
  return data;
};
export const prepareData = (values: any = null) => {
  let data: any = {};

  let form = _.cloneDeep(values);

  if(form){
    data['isSaveAsGlobalService'] = form.isSaveAsGlobalService;
    data['isSaveAsLocalService'] = true;
  }

  return data;
};


export interface initialValuesStruct {
  isSaveAsGlobalService: boolean,
  isSaveAsLocalService: boolean,
};
export const initialValues: initialValuesStruct = {
  isSaveAsGlobalService: false,
  isSaveAsLocalService: false,
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  details: any,
}


function NewReducer() {
  const name = 'jobFormBillingJobSaveServiceSlice';


  const initialState: InitState = {
    isLoading: false,
    show: false,
    details: initialValues,
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
    

    setShow: (state: InitState, action: PayloadAction<{ show: boolean, details: any }>) => {
      state.isLoading = false;
      state.details = action.payload.details;
      state.show = action.payload.show;
    },
  };


  const apis = {
    
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();